

import React, { useEffect, useRef } from 'react';

import facebook  from "../../assets/img/fb_1.png"
import linedin from "../../assets/img/linedin_1.png"
import twitter from "../../assets/img/twitter_1.png"
import dm_banner from "../../assets/img/dm_banner.png"
import { Link } from 'react-router-dom';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";  // Make sure SplitText is available
gsap.registerPlugin(ScrollTrigger, SplitText);


const hero_data = {
  title_1: "Development",
  title_2: "Operations",
  bt_text: "Our Projects",
  des: `Welcome to our digital agency! We specialize in helping businesses like yours succeed online. From website design and development to digital marketing and advertising, we have the tools.`,
  social_links: [
    {
      id: 1,
      img: facebook,
      link: "http://www.facebook.com"
    },
    {
      id: 2,
      img: linedin,
      link: "http://www.linedin.com"
    },
    {
      id: 3,
      img: twitter,
      link: "http://www.twitter.com"
    },
  ]
}

const { title_1, title_2, bt_text, des, social_links } = hero_data

const HeroHomeFive = () => {

     const containerRef = useRef();
    
      useEffect(() => {
      const timeout = setTimeout(() => {
        requestAnimationFrame(() => {
          let ctx = gsap.context(() => {
            // First: handle .anim_text_upanddowns
            let aminTextUpanddowns = gsap.utils.toArray(".anim_text_upanddowns");
    
            aminTextUpanddowns.forEach((element) => {
              let split = new SplitText(element, { type: "chars" });
    
              ScrollTrigger.create({
                trigger: element,
                start: "top 90%",
                end: "bottom 60%",
                scrub: false,
                markers: false,
                toggleActions: "play none none none",
                onEnter: () => {
                  gsap.fromTo(
                    split.chars,
                    {
                      opacity: 0,
                      scale: 1.2,
                      y: 50,
                      rotationX: 100,
                      transformOrigin: "0% 30% -30",
                    },
                    {
                      opacity: 1,
                      scale: 1,
                      y: 0,
                      rotationX: 0,
                      duration: 2,
                      delay: 0.5,
                      ease: "elastic",
                      stagger: 0.05,
                    }
                  );
                },
              });
            });
    
            // Now: handle banner text left/right/subtext
            const mark = containerRef.current.querySelector(".cs_hero .anim_banner_text_left");
            const eting = containerRef.current.querySelector(".cs_hero .anim_banner_text_right");
            const cs_hero_style5_subtext = containerRef.current.querySelector(".cs_hero .anim_subtext");
    
            if (!mark || !eting || !cs_hero_style5_subtext) return;
    
            const split_creatives = new SplitText(mark, { type: "chars,words" });
            const split_solutions = new SplitText(eting, { type: "chars,words" });
            const split_subtext = new SplitText(cs_hero_style5_subtext, { type: "words" });
    
            ScrollTrigger.create({
              trigger: containerRef.current,
              start: "top center",
              toggleActions: "play none none none",
              onEnter: () => {
                const tl = gsap.timeline();
    
                tl.from(split_creatives.chars, {
                  duration: 1.2,
                  x: 100,
                  autoAlpha: 0,
                  stagger: 0.05,
                });
    
                tl.from(
                  split_solutions.chars,
                  {
                    duration: 1,
                    x: 100,
                    autoAlpha: 0,
                    stagger: 0.01,
                  },
                  "-=1"
                );
    
                tl.from(
                  split_subtext.words,
                  {
                    duration: 1,
                    x: 50,
                    autoAlpha: 0,
                    stagger: 0.05,
                  },
                  "-=1"
                );
              },
            });
          }, containerRef);
        });
      }, 50);  // slight delay after mount
    
      return () => clearTimeout(timeout);
    }, []);
  return (
    <>
    <div ref={containerRef}>
      <div className="cs_height_219 cs_height_lg_120"></div>
      <section className="cs_shape_wrap_3">
        <div className="cs_hero cs_style5">
          <div className="container">
            <div className="cs_marketing_agency_section cs_style_1">
                <div className="cs_short_title anim_text_upanddowns">
							<h6>Welcome to DOAGuru Info Systems!</h6>
							<div className="cs_hr_design cs_color_1"></div>
						</div>
              <div className="cs_text_img">
                <h1 className="cs_banner_text cs_mp0 anim_banner_text_left">
                  {title_1}
                </h1>
                <div className="cs_img">
                  <img src={dm_banner} alt="Dmbanner" />
                </div>
              </div>
              <div className="cs_height_lg_20"></div>

              <div className="cs_text_btn anim_div_ShowDowns">
                <div className="cs_hero_btn_wrap">
                  <div className="cs_round_btn_wrap">
                    <Link href="/portfolio" className="cs_hero_btn cs_round_btn btn-item"><span></span>
                      {bt_text}
                    </Link>
                  </div>
                </div>
                <h1 className="cs_banner_text cs_text_size cs_m0 anim_banner_text_right">
                  {title_2}
                </h1>
              </div>
              <div className="cs_text_btn anim_div_ShowDowns">
               
                <h1 className="cs_banner_text cs_text_size cs_m0 anim_banner_text_right">
                  Analysis
                </h1>
              </div>
              <p className="cs_subtext anim_subtext">
                {des}
              </p>
            </div>
          </div>

          <div className="cs_icon_section">
            <p className="fontMy text-uppercase m-0">FOLLOW US</p>
            <div className="cs_hr_design"></div>
            <div className="cs_icon_img social_link">
              {social_links.map((item, i) =>
                <a key={i} href={item.link} target='_blank'>
                  <img src={item.img} alt="fb_1" className={`${i === 1 ? "social_link_style" : ""}`} />
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="cs_shape_2">
          <svg width="149" height="149" viewBox="0 0 149 149" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.23">
              <path
                d="M54.7532 1.16162C47.1932 42.2265 41.0646 48.3548 0 55.9147C41.065 63.4746 47.1932 69.6029 54.7532 110.668C62.3131 69.6029 68.4414 63.4746 109.506 55.9147C68.4414 48.3548 62.3128 42.2265 54.7532 1.16162Z"
                fill="#454545"></path>
              <path
                d="M114.179 78.1968C109.372 104.312 105.474 108.21 79.3584 113.018C105.474 117.825 109.372 121.723 114.179 147.838C118.987 121.723 122.885 117.825 149 113.018C122.884 108.21 118.987 104.312 114.179 78.1968Z"
                fill="#454545"></path>
            </g>
          </svg>
        </div>
      </section>
      <div className="cs_height_135 cs_height_lg_60"></div>
      </div>
    </>
  );
};

export default HeroHomeFive;